import React from 'react';
import SidebarTemplate from 'components/templates/SidebarTemplate';

import MonthlyShiftImport from './MonthlyShiftImport';


const MonthlyShiftImportLayoutPage: React.FC = () => (
  <SidebarTemplate>
    <MonthlyShiftImport />
  </SidebarTemplate>
);

export default MonthlyShiftImportLayoutPage;
